import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';
import { getStatusIcon, CloseIcon } from '@cognite/cogs-icons';
import { getThemeClassNames, IconWrapper } from '@cognite/cogs-utils';
import '../../tokens/color-tokens/index.js';
import '../../tokens/elevation-tokens/index.js';
import { Heading, Body } from '../../tokens/typography/typography.js';
import { Button } from '../button/button.js';
import { Flex } from '../flex/flex.js';

/**
 * Infobox is a component that is used to display information to the user.
 */
var Infobox = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var className = _a.className,
    inverted = _a.inverted,
    title = _a.title,
    _a$icon = _a.icon,
    icon = _a$icon === undefined ? true : _a$icon,
    children = _a.children,
    actions = _a.actions,
    status = _a.status,
    onClose = _a.onClose,
    _a$compact = _a.compact,
    compact = _a$compact === undefined ? false : _a$compact,
    _a$solid = _a.solid,
    solid = _a$solid === undefined ? false : _a$solid,
    otherProps = __rest(_a, ["className", "inverted", "title", "icon", "children", "actions", "status", "onClose", "compact", "solid"]);
  var InfoboxIcon = getStatusIcon(status || 'neutral');
  return jsx("div", {
    className: classNames.apply(undefined, ['cogs-v10', 'cogs-lab-infobox-wrapper'].concat(getThemeClassNames(inverted), [{
      'cogs-lab-infobox-wrapper-solid': solid
    }])),
    children: jsxs(Flex, Object.assign({
      role: "alert",
      gap: 8,
      ref: ref,
      className: classNames('cogs-v10', 'cogs-lab-infobox', "cogs-lab-infobox-" + status, compact && 'cogs-lab-infobox-compact', !title && 'cogs-lab-infobox-without-title', className)
    }, otherProps, {
      children: [icon && (InfoboxIcon ? jsx(IconWrapper, {
        className: "cogs-v10 cogs-lab-infobox__icon-wrapper",
        size: 16,
        children: jsx(InfoboxIcon, {})
      }) : null), jsxs(Flex, {
        gap: 8,
        className: "cogs-v10 cogs-lab-infobox-content",
        flex: 1,
        direction: "column",
        children: [title && jsx(Heading, {
          level: 5,
          children: title
        }), typeof children === 'string' ? jsx(Body, {
          className: "cogs-v10 cogs-lab-infobox-body",
          size: "medium",
          children: children
        }) : children, actions && jsx(Flex, {
          gap: 8,
          children: actions.map(function (action) {
            return jsx(Button, Object.assign({}, action));
          })
        })]
      }), onClose && jsx(Button, {
        size: "small",
        type: "ghost",
        "aria-label": "Close Infobox",
        icon: jsx(CloseIcon, {}),
        onClick: onClose,
        className: "cogs-v10 cogs-lab-infobox-close-button"
      })]
    }))
  });
});

export { Infobox };
